import type { IconData } from '@stacksjs/iconify-core'

export const designCropEditPicture: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M28.95 24.38V3.05H7.62V0H3.05v3.05H0v4.57h3.05v21.33h21.33V32h4.57v-3.05H32v-4.57Zm1.53 3.05h-3.05v3.05h-1.52v-3.05H4.57V6.1H1.53V4.57h3.04V1.52H6.1v3.05h21.33v21.34h3.05Z\"/><path fill=\"currentColor\" d=\"M6.1 6.1v19.81h19.81V6.1Zm18.28 9.14h-4.57v1.52h4.57v7.62h-4.57v-1.52h-1.52v1.52H7.62v-1.52h1.53v-1.53H7.62V7.62h16.76Z\"/><path fill=\"currentColor\" d=\"M18.29 16.76h1.52v1.53h-1.52Z\"/><path fill=\"currentColor\" d=\"M16.76 18.29h1.53v1.52h-1.53Zm0 3.04h1.53v1.53h-1.53Zm-1.52-1.52h1.52v1.52h-1.52Zm-4.57-4.57h3.05v-1.53h1.52v-3.04h-1.52V9.14h-3.05v1.53H9.15v3.04h1.52zm0 3.05h4.57v1.52h-4.57Zm-1.52 1.52h1.52v1.52H9.15Z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default designCropEditPicture
